export const FETCH_RESULT_SC = 'FETCH_RESULT_SC';
export const LIST_RESULT_SC = 'sc';
export const DRAW_RESULT_SC = 'DRAW_RESULT_SC';

